<script lang="ts" setup>
import Section1 from '@/pages/talent-development/components/Section1.vue'
import Section2 from '@/pages/talent-development/components/Section2.vue'
import Section3 from '@/pages/talent-development/components/Section3.vue'
import Section4 from '@/pages/talent-development/components/Section4.vue'
import Section5 from '@/pages/talent-development/components/Section5.vue'
import useSeo from './seo'

useSeo()
</script>

<template>
  <section class="career">
    <div class="career__full">
      <Section1 />
    </div>
    <div class="career__full">
      <Section2 />
    </div>
    <Section3 />
    <Section4 />
    <Section5 />
  </section>
</template>

<style lang="scss" scoped>
.career {
  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }
}
</style>
